import type { SDKConfig } from "@frontend/roz-sdk-core";
import { useContext } from "react";

import { SdkContext } from "./sdk-context";

export const useSdkConfig = (): SDKConfig => {
  const context = useContext(SdkContext);

  if (!context) {
    throw new Error("useSdkConfig must be used within an SdkProvider");
  }

  return context.config;
};
